import {getInitialState} from '../../helpers/initial-state'
import {useEnabledFeatures} from '../../hooks/use-enabled-features'

export function useIssueFieldsEnabled() {
  const {issue_fields, issue_fields_in_public_projects} = useEnabledFeatures()
  const {isOrganization, projectData} = getInitialState()
  const isPublicProject = projectData?.public === true

  if (!isOrganization || !issue_fields) return false
  if (isPublicProject) return Boolean(issue_fields_in_public_projects)
  return true
}
